import { FIELD_STATUS_VALUES } from 'business/constants';
import type { LifeCycleStatus } from 'business/types';
import TextEditor from 'ui/TextEditor/TextEditor';

type Props = {
    currentStatus: LifeCycleStatus | undefined;
    content: string | undefined;
};

const FieldStatusDescription = ({ currentStatus, content }: Props) => {
    if (
        currentStatus === FIELD_STATUS_VALUES.DEFAULT ||
        currentStatus === undefined ||
        !content
    ) {
        return <></>;
    }
    const newField = currentStatus === FIELD_STATUS_VALUES.NEW;

    return (
        <TextEditor
            key={content}
            isEditable={false}
            content={content}
            module="decision"
            mentionType="none"
            canEdit={false}
            onSave={(_) => _}
            sx={{
                border: '2px solid',
                borderColor: (theme) =>
                    newField
                        ? theme.palette.warning.main
                        : theme.palette.mediumGrey,
                borderRadius: 2,
                width: 'fit-content',
                '& .ProseMirror p': {
                    margin: 0,
                    padding: 1,
                },
            }}
        />
    );
};

export default FieldStatusDescription;
